export default class SubcategoryNav extends HTMLElement {
    constructor() {
        super();
        
        debug('SubcategoryNav');
    }
    
    connectedCallback() {        
        let filtersRegex = new RegExp('filter');        
        let searchParams = new URLSearchParams(window.location.search);        
        searchParams.forEach((value, key) => {
            if ( ! filtersRegex.test(key)) {
                searchParams.delete(key);
            }
        });
        
        if (searchParams.size > 0) {
            this.querySelectorAll('a').forEach((element) => {
                element.href += `?${searchParams.toString()}`;
            });
        }
    }
    
    disconnectedCallback() {}
}